import BroadcastMessageModal from './BroadcastMessageModal.component';

export default BroadcastMessageModal;